import * as Onboarding from '../_layout/OnboardingComponents'
import { PendingApprovalPageContent } from './_layout/PendingApprovalPageContent'
import { PendingApprovalPageSideMenu } from './_layout/PendingApprovalPageSideMenu'

function PendingApprovalPage() {
  return (
    <Onboarding.Container>
      <Onboarding.ContainerContent>
        <PendingApprovalPageContent />
      </Onboarding.ContainerContent>

      <Onboarding.ContainerSideMenu>
        <PendingApprovalPageSideMenu />
      </Onboarding.ContainerSideMenu>
    </Onboarding.Container>
  )
}

export default PendingApprovalPage
